
export function removerCaracteresEspeciais(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Adiciona caracteres de quebra de linha no formato `${prev_word} \n ${next_word}`
 * a strings que atinjam um determinado limite de caracteres
 * @param {*} stringArray
 * @param {*} maxLineCharacters
 */
export function addBreackLines(stringArray, maxLineCharacters, breakLinesQuantity = 1) {
  // string[][]
  const stringWords = stringArray.map((stringItem) => stringItem.split(' '));

  // string[]
  const newStrings = [];

  const breakLines = '\n'.repeat(breakLinesQuantity);

  stringWords.forEach((stringWords) => {
    // string[]
    const newStringWords = [];
    let charactersCount = 0;
    stringWords.forEach((stringWord) => {
      if (charactersCount >= maxLineCharacters) {
        newStringWords.push(breakLines);
        charactersCount = 0;
      }

      newStringWords.push(stringWord);
      charactersCount += stringWord.length;

      if ((newStringWords.length > 1) && (charactersCount >= maxLineCharacters)) {
        newStringWords.splice(newStringWords.length - 1, 0, breakLines);
      }
    });

    const newString = newStringWords.reduce((prev, next) => `${prev} ${next}`);
    newStrings.push(newString);
  });

  return newStrings;
}

export function addBreakLinesToSingleString(string, maxLineCharacters, breakLinesQuantity = 1) {
  if (string.length <= maxLineCharacters) {
    return string;
  }

  const start = string.slice(0, maxLineCharacters);
  const end = string.slice(maxLineCharacters);

  return start + '\n'.repeat(breakLinesQuantity) 
    + addBreakLinesToSingleString(end, maxLineCharacters, breakLinesQuantity);
}

/**
 * Adiciona uma limitação no tamanho maximo do texto
 * passado concatenado com ... 
 * @param {*} text: texto passado
 * @param {*} maxLength: tamanho máximo
 */
export function addMaxLength(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
}

/**
 * Recebe uma string e retorna ela formatada em capitalize
 * @param {*} text: texto passado
 * @returns texto formatado
 */
export function capitalizeText(text) {
  if(typeof text === 'string' && text.length) {
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  return null
}